import React, { useState, useEffect } from 'react'
import { LoaderSpinner } from '../../components/LoaderSpinner';
import { Link } from 'react-router-dom';
import $ from 'jquery'

import { useSelector, useDispatch } from 'react-redux';
import { obtenerContacto } from '../../actions/contactosActions';
import { obtenerContactoHistoryAction } from '../../actions/contactosActions';
import { obtenerCliente } from '../../actions/clientesActions';
import { obtenerContactFieldsAction } from '../../actions/customFieldsActions';
import { InteractionHistory } from '../../components/contact-history/InteractionHistory';

function FieldRow({ label, value }) {
    return (
        <div className="mb-3">
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                {label}
            </div>
            <div style={{ fontSize: 15, color: '#2c3e50', marginTop: 2 }}>
                {value || <span style={{ color: '#bbb' }}>—</span>}
            </div>
        </div>
    );
}

const isValidValue = (v) => v != null && v !== '' && String(v) !== 'null';

function TagPills({ tags }) {
    const valid = Array.isArray(tags) ? tags.filter(isValidValue) : [];
    if (valid.length === 0) {
        return <span style={{ color: '#bbb' }}>—</span>;
    }
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {valid.map((tag, i) => (
                <span key={i} style={{
                    background: '#f0f2f5',
                    borderRadius: 12,
                    padding: '2px 10px',
                    fontSize: 13,
                    color: '#555'
                }}>
                    {tag}
                </span>
            ))}
        </div>
    );
}

function MailList({ mails }) {
    const valid = Array.isArray(mails) ? mails.filter(isValidValue) : [];
    if (valid.length === 0) {
        return <span style={{ color: '#bbb' }}>—</span>;
    }
    return (
        <div>
            {valid.map((mail, i) => (
                <div key={i} style={{ fontSize: 15, color: '#2c3e50' }}>{mail}</div>
            ))}
        </div>
    );
}

export const ViewContact = () => {
    const [contactId, setContactId] = useState(null);
    const dispatch = useDispatch();

    const loading = useSelector(state => state.contactos.loading);
    const clientedit = useSelector(state => state.clientes.clientedit);
    const search_custom_page = useSelector(state => state.landings.search_custom_page);
    const contactoSearch = useSelector(state => state.contactos.contactdit);
    const contactFields = useSelector(state => state.customFields.contactsfields.normal);
    const contactFieldsCustom = useSelector(state => state.customFields.contactsfields.custom);
    const contactHistory = useSelector(state => state.contactos.contactHistory);
    const historyLoading = useSelector(state => state.contactos.historyLoading);
    const historyError = useSelector(state => state.contactos.historyError);

    const [contacto, setContacto] = useState({
        cliente_id: null,
        nombre: '',
        apellido: '',
        mail: [],
        telefono: [],
        cargo: '',
        estado: '',
        visibilidad: '',
        tags: [],
        origen: []
    });

    useEffect(async () => {
        await dispatch(obtenerContactFieldsAction());
        const idTrozos = window.location.pathname.split('/');
        if (idTrozos.length === 3) {
            setContactId(idTrozos[2]);
        }
        if (contactId && contactoSearch === null) {
            dispatch(obtenerContacto(contactId));
        }
        if (contactoSearch) {
            setContacto(contactoSearch);
            await dispatch(obtenerCliente(contactoSearch.cliente_id));
        }
        if (search_custom_page == null) {
            $('#loading').hide();
        }
    }, [contactId, contactoSearch, search_custom_page]);

    useEffect(() => {
        if (contactId) {
            dispatch(obtenerContactoHistoryAction(contactId));
        }
    }, [contactId]);

    const fieldName = (index, fallback) =>
        (contactFields && contactFields.length > index && contactFields[index]?.custom_name)
            ? contactFields[index].custom_name
            : fallback;

    const nombre = [contacto.nombre, contacto.apellido].filter(Boolean).join(' ') || '—';

    return (
        <div className="white_box QA_section card_height_100">
            <div className="p-4 d-flex align-items-center justify-content-between" style={{ borderBottom: '1px solid #f0f2f5' }}>
                <span className="naranja" style={{ fontSize: 18, fontWeight: 700 }}>Perfil de Contacto</span>
                <Link to="/contacts" className="colorsito" style={{ fontSize: 13 }}>← Volver</Link>
            </div>

            {loading ? <LoaderSpinner /> : null}

            <div className="p-4">
                {/* Header */}
                <div className="mb-4 pb-3" style={{ borderBottom: '1px solid #f0f2f5' }}>
                    <h5 style={{ fontWeight: 700, color: '#2c3e50', marginBottom: 4 }}>{nombre}</h5>
                    {contacto.cargo && (
                        <div style={{ color: '#888', fontSize: 13 }}>{contacto.cargo}</div>
                    )}
                    {clientedit && (
                        <div style={{ color: '#888', fontSize: 13, marginTop: 2 }}>
                            Cliente: {clientedit.nombre || ''}
                            {clientedit.razon_social ? ` — ${clientedit.razon_social}` : ''}
                        </div>
                    )}
                    {contacto.estado && (
                        <span style={{
                            display: 'inline-block',
                            marginTop: 8,
                            padding: '2px 12px',
                            borderRadius: 12,
                            fontSize: 12,
                            background: contacto.estado === 'activo' ? '#d4edda' : '#f8d7da',
                            color: contacto.estado === 'activo' ? '#155724' : '#721c24'
                        }}>
                            {contacto.estado === 'activo' ? 'Activo' : contacto.estado === 'bloqueado' ? 'Bloqueado' : 'Papelera'}
                        </span>
                    )}
                </div>

                {/* Datos principales */}
                <div className="mb-4">
                    <h6 style={{ fontWeight: 700, color: '#2c3e50', marginBottom: 16 }}>Datos principales</h6>
                    <div className="row">
                        <div className="col-md-6">
                            <FieldRow label={fieldName(0, 'Nombre')} value={contacto.nombre} />
                            <FieldRow label={fieldName(1, 'Apellido')} value={contacto.apellido} />
                            <div className="mb-3">
                                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                                    {fieldName(2, 'Email')}
                                </div>
                                <div style={{ marginTop: 2 }}>
                                    <MailList mails={contacto.mail} />
                                </div>
                            </div>
                            <div className="mb-3">
                                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                                    {fieldName(3, 'Teléfono')}
                                </div>
                                <div style={{ marginTop: 2 }}>
                                    <MailList mails={contacto.telefono} />
                                </div>
                            </div>
                            <FieldRow label={fieldName(4, 'Cargo')} value={contacto.cargo} />
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                                    {fieldName(5, 'Tags')}
                                </div>
                                <div style={{ marginTop: 6 }}>
                                    <TagPills tags={contacto.tags} />
                                </div>
                            </div>
                            <div className="mb-3">
                                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                                    {fieldName(6, 'Origen')}
                                </div>
                                <div style={{ marginTop: 6 }}>
                                    <TagPills tags={contacto.origen} />
                                </div>
                            </div>
                            <FieldRow label={fieldName(9, 'Cliente')} value={clientedit ? clientedit.nombre : ''} />
                            <FieldRow label={fieldName(7, 'Estado')} value={
                                contacto.estado === 'activo' ? 'Activo'
                                : contacto.estado === 'bloqueado' ? 'Bloqueado'
                                : contacto.estado === 'papelera' ? 'Papelera'
                                : contacto.estado
                            } />

                            {contactFieldsCustom && contactFieldsCustom.length > 0 && contactFieldsCustom.map((input, i) => (
                                <div key={i} className="mb-3">
                                    <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                                        {input.name}
                                    </div>
                                    <div style={{ fontSize: 15, color: '#2c3e50', marginTop: 2 }}>
                                        {input.type !== 'text'
                                            ? <TagPills tags={contacto.custom && Array.isArray(contacto.custom[input.name]) ? contacto.custom[input.name] : []} />
                                            : (contacto.custom ? contacto.custom[input.name] : '') || <span style={{ color: '#bbb' }}>—</span>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Historial de interacciones */}
                <InteractionHistory
                    summary={contactHistory ? contactHistory.summary : null}
                    events={contactHistory ? contactHistory.events : null}
                    loading={historyLoading}
                    error={historyError}
                    emptyMessage="Este contacto aún no registra interacciones de campañas o formularios."
                />
            </div>
        </div>
    );
};
